export default __webpack_public_path__ + "416bb3fe71561098bab1dea00f962af2.svg";